module.exports = __webpack_public_path__ + "static/media/do.c74cbcf4.svg";